export default __webpack_public_path__ + "static/media/coco_badge_4.3bd19ba7.svg";